module.exports = __webpack_public_path__ + "static/media/instapage9.7aac94d6.png";